import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";

import MessagePreviewScreen from "../../../shared/components/common/ui/MessagePreviewScreen/MessagePreviewScreen";

import { useWhatsAppConfig } from "./hooks/useWhatsAppConfig";
import Header from "./components/Header";
import CategoriesSelector from "./components/CategoriesSelector";
import AutoReplySection from "./components/AutoReplySection";
import SaveButton from "./components/SaveButton";

import { CATEGORIES } from "./components/constants";

export default function ViewConfigChannel() {
  const config = useWhatsAppConfig();

  const location = useLocation();
  const navigate = useNavigate();

  const channel = location.state?.channel;

  const [category, setCategory] = useState("Geral");

  useEffect(() => {
    if (!channel) {
      navigate("/canais");
    }
  }, [channel, navigate]);

  useEffect(() => {
    if (!channel) return;

    if (channel.category) {
      const normalizedCategory = CATEGORIES.find(
        (cat) => cat.toLowerCase() === channel.category.toLowerCase(),
      );

      setCategory(normalizedCategory || "Geral");
    }

    if (!channel.auto_reply) return;

    config.setAutoReplyEnabled(channel.auto_reply.enabled);

    if (channel.auto_reply.messages?.length) {
      const autoReplyMessages = channel.auto_reply.messages
        .slice(0, config.maxAutoReplyMessages)
        .map((message, index) =>
          config.createAutoReplyMessage(index, {
            content: message.content || "",
            buttons: message.buttons || [],
          }),
        );

      config.setMessages((prev) => [
        ...prev.filter((m) => !m.fromMe),
        ...autoReplyMessages,
      ]);
    }
  }, [channel]);

  if (!channel) return null;

  const hasIncomingMessage = config.messages.some(
    (message) => message?.fromMe === false,
  );
  const shouldApplyAutoReplyPreviewRules = config.autoReplyEnabled && hasIncomingMessage;
  const previewMessages = config.autoReplyEnabled
    ? config.messages
    : config.messages.filter((message) => message?.fromMe === false);

  const handleSave = async () => {
    const success = await config.save(
      channel.id,
      channel.type, 
      category,
    );

    if (success) {
      alert("Configurações salvas com sucesso!");
    }
  };

  return (
    <Box sx={{ width: "100%", padding: "40px", backgroundColor: "#f5f6fa" }}>
      <Grid container spacing={4}>
        <Grid item xs={12} md={6}>
          <Grid container spacing={2}>
            <Header
              instanceName={channel.instance_name}
              status={channel.status}
              sender={channel.sender}
            />

            <Grid item xs={12}>
              <CategoriesSelector value={category} onChange={setCategory} />
            </Grid>

            <AutoReplySection
              enabled={config.autoReplyEnabled}
              error={config.autoReplyError}
              messages={config.messages}
              setMessages={config.setMessages}
              createAutoReplyMessage={config.createAutoReplyMessage}
              maxMessages={config.maxAutoReplyMessages}
              onToggle={(e) => config.setAutoReplyEnabled(e.target.checked)}
            />

            <SaveButton onClick={handleSave} />
          </Grid>
        </Grid>

        <Grid item xs={12} md={6}>
          <Box
            sx={{
              backgroundColor: "background.paper",
              borderRadius: 2,
              p: 3,
              boxShadow: 1,
              height: "100%",
            }}
          >
            <MessagePreviewScreen
              channel={channel.type}
              messages={previewMessages}
              allowedButtonTypes={["open_url", "opt_out_url"]}
              hideMediaConfigMenu={shouldApplyAutoReplyPreviewRules}
              highlightIncomingMessage={hasIncomingMessage}
              onChangeMessageButtons={(id, buttons) =>
                config.setMessages((prev) =>
                  prev.map((m) => (m.id === id ? { ...m, buttons } : m)),
                )
              }
            />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}
